// JSON modules are default-only, so this pulls the manifest in and reads one field.
import pkg from "../package.json" with { type: "json" };

/**
 * Single source of truth for the published version.
 *
 * The CLI banner, `carrier --version`, the stdio MCP server's clientInfo and the
 * `carrier ask` handshake all read this. It used to be typed out in four places,
 * which is how seven commits shipped under a stale version string. Bump
 * package.json and every surface follows.
 */
export const CARRIER_VERSION: string = pkg.version;
